import { render, staticRenderFns } from "./alertconfigitem.vue?vue&type=template&id=72e755a6&scoped=true&"
import script from "./alertconfigitem.vue?vue&type=script&lang=js&"
export * from "./alertconfigitem.vue?vue&type=script&lang=js&"
import style0 from "./alertconfigitem.vue?vue&type=style&index=0&id=72e755a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e755a6",
  null
  
)

export default component.exports